/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LocationDto interface.
 */
export function instanceOfLocationDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('brandId' in value) || value['brandId'] === undefined)
        return false;
    return true;
}
export function LocationDtoFromJSON(json) {
    return LocationDtoFromJSONTyped(json, false);
}
export function LocationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'brandId': json['brandId'],
    };
}
export function LocationDtoToJSON(json) {
    return LocationDtoToJSONTyped(json, false);
}
export function LocationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'brandId': value['brandId'],
    };
}
//# sourceMappingURL=LocationDto.js.map